import React from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./NavigationBar.css";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

export default function NavigationBar() {
  const [searchTerm, setSearchTerm] = React.useState();
  return (
    <Navbar expand="md" className="bg-body-tertiary" sticky="top">
      <Navbar.Brand className="home" as={Link} to="/">
        Helping Hand
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="align-bottom">
        <Nav className="me-auto">
          <Nav.Link className="ms-3 link" as={Link} to="/counties">
            Counties
          </Nav.Link>
          <Nav.Link className="ms-3 link" as={Link} to="/nonprofits">
            Non-Profits
          </Nav.Link>
          <Nav.Link className="ms-3 link" as={Link} to="/healthcenters">
            Health Centers
          </Nav.Link>
          <Nav.Link className="ms-3 link" as={Link} to="/about">
            About
          </Nav.Link>
        </Nav>
        <Form
          className="d-flex ms-auto"
          style={{ marginRight: "20px", paddingLeft: "20px" }}
        >
          <InputGroup>
            <Form.Control
              size="sm"
              type="text"
              placeholder="Search..."
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button variant="primary" as={Link} to={`/search/${searchTerm}`}>
              Search
            </Button>
          </InputGroup>
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
}
